<template>
	<div class="box">
		<!--<img class="logo" src="../assets/logo2.png"/>-->
		<div class="btn btn1" @click="goToQYD"></div>
		<div class="btn btn2" @click="goToGCSD"></div>
		<div class="btn btn3" @click="goToGCD"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mac: ''
			}
		},
		created() {
			document.title = "桃琼之瑶SMT活动钢网交易平台";
			console.log(this.$route.query.mac || '获取不到mac地址');
			window.localStorage.setItem('MAC',this.$route.query.mac || '');
			this.mac = this.$route.query.mac || '';
		},
		mounted() {

		},
		methods: {
			goToQYD(){
				window.location.href = 'https://mr.summary88.com/mrgw_qyd/#/login';
			},
			goToGCSD(){
				window.location.href = 'https://mr.summary88.com/mrgw_gcsd/#/login?mac='+this.mac;
			},
			goToGCD(){
				window.location.href = 'https://mr.summary88.com/mrgw_gcd/#/login';
			},
		},
	}
</script>

<style scoped="scoped">
	.logo {
		width: 576px;
		position: absolute;
		top: 25px;
		left: 200px;
		cursor: pointer;
	}
	
	.box {
		width: 100%;
		height: 100%;
		background: url(../assets/background.jpg) no-repeat;
		background-size: cover;
		box-sizing: border-box;
		padding: 408px 0 0;
		display: flex;
		justify-content: center;
	}
	.btn {
		width: 315px;
		height: 205px;
		margin-right: 120px;
		cursor: pointer;
		border-radius: 10px;
		transition: all 0.1s;
	}
	
	.btn:hover {
		transform: scale(1.05,1.05);
		box-shadow: 0 0 5px 5px rgba(0,0,0,0.2);
	}
	
	.btn1 {
		background: url(../assets/btn1.png) no-repeat;
		background-size: 100% 100%;
	}
	
	.btn2 {
		background: url(../assets/btn2.png) no-repeat;
		background-size: 100% 100%;
	}
	
	.btn3 {
		background: url(../assets/btn3.png) no-repeat;
		background-size: 100% 100%;
		margin-right: 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/welcome.vue